import { render, staticRenderFns } from "./Breast.vue?vue&type=template&id=5a8c2b62&scoped=true&"
import script from "./Breast.vue?vue&type=script&lang=js&"
export * from "./Breast.vue?vue&type=script&lang=js&"
import style0 from "./Breast.vue?vue&type=style&index=0&id=5a8c2b62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8c2b62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
